import * as React from "react";
import { observer } from "mobx-react";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import { Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { Travelers } from "components/shared/Travelers/Travelers";
import { TravelersTriggerTypes } from "components/shared/TravelersField/typings";
import { PreferredClassInput } from "components/shared/PreferredClassInput/PreferredClassInput";
import { PreferredAirlineInput } from "components/shared/PreferredAirlineInput/PreferredAirlineInput";

export const FlightPreferences = observer((props: FlightSubLOBProps) => {
  const {
    flightWizardState,
    flightWizardState: { config: flightConfig },
  } = props.wizardState;

  const { config, isAddAHotelChecked, isAddACarChecked } = flightWizardState;
  const travelerConfig =
    config.enableAddHotel && isAddAHotelChecked
      ? config.travelersWithHotel
      : config.enableAddCar && isAddACarChecked
      ? config.travelersWithCar
      : config.travelers;

  const { noRehydratationValues } = flightConfig.travelers;

  const travelersColSpan: UitkLayoutConditionalGridSpan = { small: 2, large: 12 };
  const preferredClassColSpan: UitkLayoutConditionalGridSpan = { small: 1, large: 4 };

  return (
    <Viewport>
      <ViewSmall>
        <UitkLayoutGridItem colSpan="all">
          <UitkLayoutFlex space="two">
            <UitkLayoutFlexItem>
              <Travelers
                lobState={flightWizardState}
                config={travelerConfig}
                colSpan={travelersColSpan}
                noRehydratationValues={noRehydratationValues}
                triggerType={TravelersTriggerTypes.LINK_BUTTON}
              />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <PreferredClassInput
                colSpan={preferredClassColSpan}
                onSelectPreferredClassCode={props.onSelectPreferredClassCode}
                wizardState={props.wizardState}
              />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <PreferredAirlineInput
                onSelectPreferredAirline={props.onSelectPreferredAirline}
                wizardState={props.wizardState}
              />
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      </ViewSmall>
    </Viewport>
  );
});
